import { GridActionsCellItem } from "@mui/x-data-grid";
import { immerable } from "immer";
import { EnvType, supportService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { useContext } from "react";
import { ModalContext } from "../../Modals";
import ModalReportIssue, { ModalReportIssueElementProps } from "../../Modals/ModalReportIssue/modal-report-issue";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import { useTranslation } from "react-i18next";

export type TableCellActionReportIssueProps = {
  showInMenu?: boolean;
  text: string;
  typology: string;
  objectId: number;
};

const TableCellActionReportIssue: React.FC<TableCellActionReportIssueProps> = (props) => {
  const { t } = useTranslation();
  const { showInMenu = true, text, typology, objectId, ...otherProps } = props;

  // Context
  const modalContext = useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const enqueueCustomSnackbar = useCustomSnackbar();

  return (
    <>
      {GlobalConst.ZENDESK_ENABLED ? (
        <GridActionsCellItem
          icon={<ReportProblemIcon />}
          label={t("modal:title.reportIssue")}
          onClick={() => {
            if (!openModal) return;

            openModal<ModalReportIssueElementProps>(ModalReportIssue, {
              typology: typology,
              techInfos: text,
              objectId: objectId,
              onConfirm: (subject, subTypology, priority, followers, description, file) => {
                let requestData = {
                  subject: subject,
                  techInfos: text ?? "",
                  description: description ?? "",
                  typology: typology,
                  subTypology: subTypology,
                  objectId: objectId !== null ? objectId : -500,
                  priority: priority,
                  followers: followers,
                  [immerable]: true,
                };

                supportService.CreateZendeskIssue(requestData, file).then((response) => {
                  if (response.success) {
                    enqueueCustomSnackbar(t("alert:success.ticketCreated"), "success");
                  }
                });
              },
            });
          }}
          showInMenu={showInMenu}
          {...otherProps}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default TableCellActionReportIssue;
